import { useTheme } from '@material-ui/core/styles';
import { DASHBOARD_COLORS } from './statusDashboardStyles';

interface MetricBarProps {
  value: number;
  height?: number;
  color?: string;
}

export const MetricBar = ({ value, height = 8, color }: MetricBarProps) => {
  const theme = useTheme();
  const width = Math.min(Math.max(value, 1.2), 100);
  return (
    <div style={{ height, borderRadius: 9999, background: DASHBOARD_COLORS.neutral100, overflow: 'hidden' }}>
      <div
        style={{
          height,
          width: `${width}%`,
          borderRadius: 9999,
          background: color ?? theme.palette.primary.main,
        }}
      />
    </div>
  );
};
